import {Component, OnInit, OnDestroy, HostListener, ElementRef} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {AppCatalogService} from '../../services/app-catalog-service';
import {GeneratorsService} from '../../services/generators-service';
import {AppService} from '../../../../shared/services/app-service';

// Classes
import {Product} from '../../classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:GeneratorConfiguratorCmp'));

// TODO: Move most of the methods to generatorService
@Component({
    selector: 'generator-configurator-cmp',
    template: require('./generator-configurator.cmp.html'),
    styles: [String(require('./generator-configurator.cmp.scss'))],
    host: { class: 'generator-configurator' }
})
export class GeneratorConfiguratorCmp {

    @HostListener('window:resize', ['$event']) onResize(event) {
        this._resetTitleLabelHeight();
    }

    private _generatorCfg;
    private _roomDimensions;
    private _imgPaths = null;
    private _generators = null;
    private _mutationObserver = null;
    private _materialsDropdownIsRendered = false;
    private _materialsDropdownIsVisible = false;
    private _currentTab = 1;

    // TODO: Move all copies to a common service
    private _dic = {
        stone: 'Natural Stone',
        ceramic: 'Ceramic, Porcelain, Glass Tile',
        acrylic: 'Acrylic, Fiberglass, Composite'
    };
    private _dom = {
        catalog: null,
        generators: null,
        generatorsTitleLabel: null,
        generatorLengthIn: null,
        generatorWidthIn: null,
        generatorHeightIn: null
    };

    
    constructor (
        private _catalogService: CatalogService,
        private _appCatalogService: AppCatalogService,
        private _generatorsService: GeneratorsService,
        private _appService: AppService,
        private _elementRef: ElementRef
    ) {
        // 'Construct generator configurator component' );

        this._imgPaths = this._catalogService.imgPaths;
        this._dom.generators = _elementRef.nativeElement;

        // Cache generators state
        this._generatorCfg = this._generatorsService.state.generatorCfg;
        this._roomDimensions = this._generatorsService.state.roomDimensions;
    }

    
    ngOnInit () {
        let self = this;

        // Cache dom elements
        this._dom.catalog = document.getElementById( 'catalog-host' );
        this._dom.generatorsTitleLabel = document.getElementById( 'generators-title-label' );
        this._dom.generatorLengthIn = document.getElementById( 'generator-length-in' );
        this._dom.generatorWidthIn = document.getElementById( 'generator-width-in' );
        this._dom.generatorHeightIn = document.getElementById( 'generator-height-in' );

        // Detect with mutation observer when to adjust title height
        this._mutationObserver = new MutationObserver( mutation => self._resetTitleLabelHeight() );
        this._mutationObserver.observe( this._dom.catalog, { childList: true, subtree: true } );

        // Get generators
        this._generators = this._catalogService.getProductsByCategoryId( 'generators' );
        // 'Generators:', this._generators );

        this._appService.roomDimensions = this._roomDimensions;
        this._appService.generatorCfg = this._generatorCfg;

    }

    
    ngOnDestroy () {
        this._mutationObserver.disconnect();
    }

    
    private _openDropdown () {
        // 'Open dropdown' );

        let self = this;

        this._materialsDropdownIsRendered = true;
        setTimeout(() => self._materialsDropdownIsVisible = true, 0);
    }

    
    private _closeDropdown () {
        // 'Close dropdown' );
        let self = this;

        this._materialsDropdownIsVisible = false;
        setTimeout(() => self._materialsDropdownIsRendered = false, 200);
    }

    
    private _selectOption (type) {
        // 'Select "' + type + '" option' );

        this._roomDimensions.wallType = type;
        this._closeDropdown();
        this._updateConfiguratorVars();
    }

    
    private _updateConfiguratorVars () {
        // 'Updated generator configurator variables' );
        
        this._validateFields();
        this._calculateRoomVolume();

        // Prevent more than 11 inches
        this._roomDimensions.lengthIn > 11 && (this._roomDimensions.lengthIn = 11);
        this._roomDimensions.widthIn > 11 && (this._roomDimensions.widthIn = 11);
        this._roomDimensions.heightIn > 11 && (this._roomDimensions.heightIn = 11);
        this._dom.generatorLengthIn.value = this._roomDimensions.lengthIn;
        this._dom.generatorWidthIn.value = this._roomDimensions.widthIn;
        this._dom.generatorHeightIn.value = this._roomDimensions.heightIn;

        // Shift user attention to material dropdown
        if (this._generatorCfg.lengthFtIsValid === true &&
            this._generatorCfg.widthFtIsValid === true &&
            this._generatorCfg.heightFtIsValid === true &&
            this._roomDimensions.wallType === null
        ) {
            this._openDropdown();
        }
    };

    
    private _validateFields () {
        debugOff( 'Validate fields' );

        let length = parseInt( this._roomDimensions.lengthFt ),
            width = parseInt( this._roomDimensions.widthFt ),
            height = parseInt( this._roomDimensions.heightFt ),
            material = parseInt(this._roomDimensions.wallType);

        this._generatorCfg.lengthFtIsValid =
        this._generatorCfg.widthFtIsValid =
        this._generatorCfg.heightFtIsValid =
        this._generatorCfg.materialIsValid = false;

        if (typeof length === 'number' && length > 0) { this._generatorCfg.lengthFtIsValid = true; }
        if (typeof width === 'number' && width > 0) { this._generatorCfg.widthFtIsValid = true; }
        if (typeof height === 'number' && height > 0) { this._generatorCfg.heightFtIsValid = true; }
        if (material !== null) { this._generatorCfg.materialIsValid = true; }
    }

    
    private _calculateRoomVolume () {
        // 'Calculate room volume' ); // verbose

        // Init variables
        let size = [ 71, 107, 161, 257, 339, 411, 482, 678, 822, 964, 0 ],
            model = [
                'MS90EC1', 'MS150EC1', 'MS225EC1', 'MS400EC1',
                'MSSUPER1EC1', 'MSSUPER2EC1', 'MSSUPER3EC1',
                'MX4EC1', 'MX5EC1', 'MX6EC1',
                '0'
            ],
            walltype = this._roomDimensions.wallType,
            decLengthFt = parseFloat( this._roomDimensions.lengthFt ),
            decWidthFt = parseFloat( this._roomDimensions.widthFt ),
            decHeightFt  = parseFloat( this._roomDimensions.heightFt ),
            decLengthIn:any = this._roomDimensions.lengthIn / 12,
            decWidthIn = this._roomDimensions.widthIn / 12,
            decHeightIn = this._roomDimensions.heightIn / 12,
            lenght = decLengthFt + decLengthIn,
            width = decWidthFt + decWidthIn,
            height = decHeightFt  + decHeightIn,
            cubicFeet = null,
            cubicFeetAdjusted,
            addPercent = 0;

        // Calculate cubic feet
        if (isNaN( decLengthFt ) || decLengthFt === 0 ||
            isNaN( decWidthFt ) || decWidthFt === 0 ||
            isNaN( decHeightFt ) || decHeightFt === 0
        ) {
            cubicFeet = 0;
        } else {
            cubicFeet = lenght * width * height;
        
        }

        // Adjust cubic feet value for material type
        walltype === 'stone' && ( addPercent += 50 );
        walltype === 'ceramic' && ( addPercent += 0 );
        walltype === 'acrylic' && ( addPercent -=40 );
        let materialAdjusted = cubicFeet + cubicFeet * addPercent / 100;
        height > 8 && height <= 9 && ( addPercent = 15 );
        height > 9 && height <= 10 && ( addPercent = 30 );
        height <= 8  && ( addPercent = 0 );
        cubicFeetAdjusted = materialAdjusted + materialAdjusted * addPercent / 100;
        this._roomDimensions.cubicFeet = cubicFeet;
        this._roomDimensions.cubicFeetAdjusted = cubicFeetAdjusted;
        
        // Update selected generator
        if (cubicFeetAdjusted > 0 && walltype !== null) {

            let sizeIndex = 0,
                sizeIndexCalculated = false;

            for (let i = 0; i < size.length; i++) {
                if (cubicFeetAdjusted <= size[i] && height <= 10) {

                    sizeIndex = i;
                    sizeIndexCalculated = true;
                    break;
                }
            }

            if (sizeIndexCalculated === true) {

                // Get generator id
                let generatorId = model[ sizeIndex ];
                debugOff( 'Recommended generator id:', generatorId );

                // Get generator object
                let generator = this._catalogService.getProductById( generatorId );
                debugOff( 'Recommended generator:', generator );

                if (generator !== undefined) {

                    // Update selected generator
                    this._generatorCfg.selectedGenerator !== null && this._deselectGenerator();
                    this._selectGenerator( generator );
                    this._generatorCfg.showerDimensionsExceeded = false;
                } else {
                    console.error( 'Could not find product with requested "' + generatorId + '" generator id' );
                }
            } else {
                this._generatorCfg.selectedGenerator !== null && this._deselectGenerator();
                this._generatorCfg.showerDimensionsExceeded = true;
            }
        } else {
            this._generatorCfg.selectedGenerator !== null && this._deselectGenerator();
        }

    }

    
    private _selectGenerator ( generator: Product ) {
        // 'Select "' + generator.code + '" generator' );
        debugOff( 'Selected Generator:', generator );

        // Select generator
        this._generatorCfg.selectedGenerator = generator;
        this._generatorCfg.selectedGenerator.addToCart( 'generators' );
        this._generatorCfg.selectedGenerator.displayTooltip();

        // this._uiLayoutService.events.generatorSelected.emit( 'generatorSelected' );
    }

    
    _deselectGenerator () {
        // 'Deselect Generator' );

        // Deselect generator
        let genReference: Product = this._generatorCfg.selectedGenerator;
        this._generatorCfg.selectedGenerator = null;

        // Deselect generator after state flags have been updated
        genReference.removeFromCart();

        // this._uiLayoutService.events.generatorDeselected.emit( 'generatorDeselected' );
    }

    // TODO: Skip generator selection
    
    private _skipGeneratorSelection() {
        // 'Skip generator selection' );

        // If there is already one selected remove it
        if (this._generatorCfg.selectedGenerator !== null) {
            this._deselectGenerator();
        }

        // Reset calculator inputs
        this._generatorsService.resetCalculatorInputs();

        // Go to individual controls
        this._appCatalogService.selectCategory({ category: 'steam-shower-controls' });

    }

    /** Measure title label height as a flexible element in order to set fixed height.
     * This operation allows the css height reduction animation to play smoothly.
     */
    private _resetTitleLabelHeight () {
        debugOff( 'Reset title label height' );

        let height;
        this._dom.generatorsTitleLabel.style.removeProperty( 'height' );
        height = this._dom.generatorsTitleLabel.clientHeight;
        this._dom.generatorsTitleLabel.style.height = height + 'px';
    }

    
    private _roundRoomVolume(volume) {
        debugOff( 'Round room volume' );
        return Math.ceil(volume);
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/custom-categories/generator-configurator.cmp.ts